import { useAuth, useRequest } from '@polvo-labs/react-auth'
import React, { useContext, useEffect, useRef, useState } from 'react'
import { toast } from 'react-toastify'
import Form from '../../../components/Form'
import FieldType from '../../../components/Form/Fields/type'
import { RoomsContext } from '../../../context/rooms-context'
import isAdmin from '../../../utils/is-admin'
import Button from '../../Button'
import Select from '../../Form/Fields/Select'
import Icon from '../../Icon'
import Loader from '../../Loader'
import Modal from '../../Modal'
import { MessageCreate, Upload } from '../type'
import { Actions, DocumentContainer, ModalContent as Container } from './styles'

interface Props {
  onChange: (message: MessageCreate) => void
}

const Document: React.FC<Props> = ({ onChange }) => {
  const [open, setOpen] = useState(false)
  const [document, setDocument] = useState<Upload>()
  const [realty_id, setRealtyId] = useState<any>()
  const { user } = useAuth()
  const { roomsState, roomsDispatch } = useContext(RoomsContext)
  const room = roomsState.room
  const [selectFields, setSelectFields] = useState<FieldType<RealtyForm>[]>([
    {
      name: 'realty',
      component: Select,
      data: {
        label: 'Associar a uma Imóveis',
        icon: 'home',
        options: [
          {
            label: 'Selecione a uma Imóveis',
            value: '',
          }
        ],
      },
      html: {},
    }
  ])

  const { request } = useRequest()
  const [uploading, setUploading] = useState(false)
  const ref = useRef<HTMLInputElement>(null)

  const handleClick = () => {
    if (ref && ref.current) {
      const input = ref.current

      if (input) {
        input.click()
      }
    }
  }

  const handleChangeRealty = (event: React.ChangeEvent<HTMLSelectElement>) => {
    event.preventDefault()
    const realty_id = event.target.value
    setRealtyId(realty_id)
  }

  interface RealtyFormData {
    realty: number
  }

  type RealtyForm = keyof RealtyFormData


  useEffect(() => {
    let mounted = true;
    let url = `${process.env.REACT_APP_API_URL}/realties`
    if (isAdmin(user)) {
      const userId = room?.user.id
      url = url + `?user_id=${userId}`
    }
    request({
      method: 'GET',
      url: url,
    }).then(({ data }) => {
      if (mounted) {
        if (data && data.data) {
          let options = [
            {
              label: 'Selecione a uma Imóveis',
              value: '',
            }
          ]

          data.data.map((item: { type: any; registration_number: any; id: any }) => {
            const option = {
              label: `${item.type} - ${item.registration_number}`,
              value: item.id
            }
            options.push(option)
            return option
          })

          const field: FieldType<RealtyForm> = {
            name: 'realty',
            component: Select,
            data: {
              label: 'Associar a uma Imóveis',
              icon: 'home',
              options: options,
            },
            html: {
              value: realty_id,
              onChange: handleChangeRealty
            },
          }
          let selectFields: FieldType<RealtyForm>[] = [field]
          setSelectFields(selectFields)
        }
      }
    }).catch(() => {

    })
    return () => {
      mounted = false
    };

  }, [room])

  useEffect(() => {
    if (document) {
      if (realty_id !== '') {
        const newDoc = Object.assign(document, { realty_id: realty_id })
        setDocument(newDoc)
      } else {
        delete document.realty_id
        const newDoc = Object.assign(document, {})
        setDocument(newDoc)
      }

    }
  }, [realty_id])

  const handleFile = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (event.target.files?.length === 1) {
      if (event.target.files[0].size > 20000000) {
        toast.error('Arquivo não deve exceder 20MB de tamanho.')
        return
      }
      const formData = new FormData()
      formData.append('files[]', event.target.files[0])
      setUploading(true)
      request({
        method: 'POST',
        url: `${process.env.REACT_APP_API_URL}/chat/uploads`,
        data: formData,
      }).then(({ data }) => {
        toast.info('Upload realizado com sucesso')
        setUploading(false)
        if (data && data.data) {
          setDocument(data.data[0])
        }
      }).catch(() => {
        toast.error('Ocorreu um erro ao fazer o upload')
        setUploading(false)
      })
    }
  }

  return (
    <>
      <Button
        before={(
          <Icon
            name="document"
          />
        )}
        label="Escolher um arquivo"
        backgroundColor="transparent"
        fontColor="darkGray"
        smallPadding
        alignText="flex-start"
        onClick={() => setOpen(true)}
      />

      <Modal
        open={open}
        onToggle={open => {
          setDocument(undefined)
          setOpen(open)
        }}
      >
        <Container>
          <input
            type="file"
            ref={ref}
            accept="file/*"
            hidden
            onChange={handleFile}
          />

          {document && (
            <DocumentContainer>
              {document.name}
              <Form<RealtyFormData>
                fields={selectFields}
                onSubmit={() => { }}
                hasSubmitButton={false}
              />
            </DocumentContainer>
          )}

          {document ? (
            <Actions>
              <Button
                label="REMOVER DOCUMENTO"
                backgroundColor="red"
                onClick={() => {
                  const input = ref.current as unknown as HTMLInputElement
                  input.value = ''
                  setDocument(undefined)
                }}
              />

              <Button
                label="ESCOLHER DOCUMENTO"
                onClick={() => {
                  onChange({
                    type: 'DOCUMENT',
                    upload: document,
                  })
                  setOpen(false)
                }}
              />
            </Actions>
          ) : (
              <Button
                label="SELECIONAR DOCUMENTO"
                onClick={handleClick}
              />
            )}
        </Container>

        {uploading && (
          <Loader
            delay={0}
            full
          />
        )}
      </Modal>
    </>
  )
}

export default Document
